import VerbachatIcon from "../../../../../../../assets/svg/verbachat-icon";
import AiSummaryIcon from "../../../../../../../assets/svg/ai-summary-icon";
import AttachmentInputIcon from "../../../../../../../assets/svg/attachment-input-icon";
import LogsIcon from "../../../../../../../assets/svg/logs-icon";
import TicketDetailsIcon from "../../../../../../../assets/svg/ticket-details-icon";
import { getHelpdeskLabels } from "../../../../../../../utils/constants/mappings";

export const getTicketDetailsRightSidebarItems = (region?: string) => {
  const helpdeskLabels = getHelpdeskLabels(region);
  return [
    {
      id: "activity",
      label: "Activity",
      panelTitle: "Activity",
      icon: VerbachatIcon,
    },
    {
      id: "ai-summary",
      label: "AI Summary",
      panelTitle: "AI Summary",
      icon: AiSummaryIcon,
    },
    {
      id: "attachments",
      label: "Attachments",
      panelTitle: "Attachments",
      icon: AttachmentInputIcon,
    },
    {
      id: "logs",
      label: "Logs",
      panelTitle: "Logs",
      icon: LogsIcon,
    },
    {
      id: "details",
      label: "Details",
      panelTitle: helpdeskLabels.ticketDetails,
      icon: TicketDetailsIcon,
    },
  ];
};
